/**
 * Renders a JSON-LD structured-data block.
 *
 * IMPORTANT: this must render inside <body>, not <head>, and must NOT be moved
 * to React Router's `script:ld+json` meta descriptor. React 19 does not adopt
 * server-rendered <script> elements in <head> during hydration - it appends a
 * second identical copy, so the page ships duplicate schema. <meta>, <link> and
 * <title> are hoistable and dedupe correctly; <script> does not. JSON-LD is
 * valid anywhere in the document, so body placement keeps exactly one copy on
 * both server and client. (Verified against the FAQPage block on /support,
 * which has always rendered from the body and has never duplicated.)
 *
 * No nonce is needed: application/ld+json is a data block, not executable
 * script, so it is not subject to the CSP script-src directive.
 */
export function JsonLd({ data }: { data: Record<string, unknown> }) {
	// `<` is escaped to its JSON unicode form so a value containing `</script>`
	// cannot close this block early. Every field here is developer-authored
	// today, so this is defence in depth rather than a fix for a live hole.
	const json = JSON.stringify(data).replace(/</g, '\\u003c')

	return (
		<script
			type="application/ld+json"
			dangerouslySetInnerHTML={{ __html: json }}
		/>
	)
}
